import { DashboardModule } from '@domain-group/suit-theme'

import useCampaignPortalSyncs from '@hooks/useCampaignPortalSyncs'

import type { CampaignPortalSyncModel } from '@models/types'

import CampaignPortalSyncListItem from './CampaignPortalSyncListItem'

interface SyncHistoryProps {
  campaignId: number,
}

const SyncHistory = (props: SyncHistoryProps) => {
  const { campaignId } = props

  const campaignPortalSyncsPayload = useCampaignPortalSyncs({
    filters: {
      campaign_id: campaignId,
    },
    performHttpRequests: !!campaignId,
    requestOptions: {
      include_campaign_portal_sync_file: true,
    },
  })

  const {
    filteredCampaignPortalSyncs,
    hasFilteredCampaignPortalSyncs,
  } = campaignPortalSyncsPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title="Sync History"
    >
      {!hasFilteredCampaignPortalSyncs && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Sync History Present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}

      {filteredCampaignPortalSyncs.map(campaignPortalSync => (
        <CampaignPortalSyncListItem campaignPortalSync={campaignPortalSync} />
      ))}
    </DashboardModule>
  )
}

export default SyncHistory
